import { cronosClient } from "@/config/client"

type ProductTourStatus = "completed" | "skipped" | null

export interface User {
  id: string
  firstName: string
  lastName: string
  universityId: string
  externalId: string
  role: UserRole
  dailyStudyHours: number
  profilePicUrl: string
  emailAddress: string
  sex: UserSex
  timeZone: string
  wasOnboarded: boolean
  productTour: ProductTourStatus
}

export enum UserRole {
  STUDENT = "student",
  SUPERVISOR = "supervisor",
}

export enum UserSex {
  F = "F",
  M = "M",
  X = "X",
}

export interface LoginResponse {
  description: {
    user: User
    token: string
  }
}

export interface LoginRequestParams {
  email: string
  password: string
}

export function logIn(params: LoginRequestParams) {
  return cronosClient.post<LoginResponse, LoginRequestParams>("/v1/auth/login", { ...params })
}
